/*
  <petro-carousel>: a native horizontal scroll-snap track with prev / next buttons.
  Used by PETRO sections (Featured Projects, product sliders). Swipe and trackpad scrolling work natively;
  the buttons move by one card and switch between active (orange) and inactive (outline) at either end.

  Markup:
  <petro-carousel>
    <div data-petro-carousel-track> ...cards... </div>
    <button data-petro-carousel-prev></button>
    <button data-petro-carousel-next></button>
  </petro-carousel>
*/
if (!customElements.get('petro-carousel')) {
  customElements.define(
    'petro-carousel',
    class PetroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-petro-carousel-track]');
        this.prev = this.querySelector('[data-petro-carousel-prev]');
        this.next = this.querySelector('[data-petro-carousel-next]');
        if (!this.track || !this.prev || !this.next) return;

        this.prev.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));

        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.resizeObserver?.disconnect();
      }

      step() {
        const card = this.track.firstElementChild;
        if (!card) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      move(direction) {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.step(), behavior: reduced ? 'auto' : 'smooth' });
      }

      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        const atStart = this.track.scrollLeft <= 2;
        const atEnd = this.track.scrollLeft >= max;
        this.prev.disabled = atStart;
        this.next.disabled = atEnd;
        this.toggleAttribute('data-scrollable', max > 0);
      }
    }
  );
}
